import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import React from "react";
import ReactPlayer from "react-player/youtube";
import { Container, Row, Col } from "reactstrap";
import { useRouter } from "next/router";
import JobSearch from "@sourceflow-uk/job-search";
import Link from "next/link";
import styles from "./styles.module.scss";
import Arrow from "/public/site-assets/svg/arrow.svg";
import AnchorLink from "react-anchor-link-smooth-scroll";
import BreadCrumb from "../../components/Shared/BreadCrumb";

export const MainBanner = ({
  className,
  title,
  titleColour,
  content,
  image,
  video,
  breadcrumb_title,
  secondary_breadcrumb_url,
  secondary_breadcrumb_title,
  // returnLinkURL,
  // returnLinkTitle,
  buttonLink,
  buttonTitle,
  buttonNewTab,
  buttons = [],
  buttonLayout = "horizontal",
  hero,
}) => {
  const locale = useRouter().asPath.startsWith("/us/") ? "/us/" : "/";

  const buttonContainerClasses =
    buttonLayout === "vertical"
      ? "d-flex flex-column align-items-start gap-3 mt-4"
      : "d-flex flex-wrap align-items-center gap-3 mt-4";

  return (
    <section
      className={`${styles.root} ${className} ${
        hero?.active ? styles.hero : null
      }`}
    >
      <Container>
        <Row className="m-0">
          <Col
            lg={6}
            className="contentWrapper d-flex flex-wrap align-items-center position-relative"
          >
            <div className={`position-relative wrapper mb-4 w-100`}>
              {breadcrumb_title && (
                <BreadCrumb
                  title={
                    <>
                      {secondary_breadcrumb_url && (
                        <span>
                          <Link href={secondary_breadcrumb_url}>
                            <a>{secondary_breadcrumb_title}</a>
                          </Link>
                        </span>
                      )}

                      <span className="active">{breadcrumb_title}</span>
                    </>
                  }
                  className={`py-2`}
                />
              )}
            </div>
            <div className="w-100">
              {/* {returnLinkURL && (
                <Link href={returnLinkURL}>
                  <a className="return-text text-nowrap arrow-left d-inline-flex align-items-center white mb-4">
                    <strong>{returnLinkTitle}</strong>
                  </a>
                </Link>
              )} */}
              <h1
                className={`text-${titleColour?.variant}`}
                style={{ color: titleColour?.custom }}
              >
                {title}
              </h1>
              {content && (
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              )}
              {buttons && buttons.length > 0 ? (
                <div className={buttonContainerClasses}>
                  {buttons.map((button, index) => {
                    const isLink =
                      button.variant === "secondaryLink" ||
                      button.variant === "secondaryLinkWhite";
                    const finalButtonClass = `${
                      button.variant || "primaryBtn"
                    } ${!isLink ? "no-arrow" : ""}`;

                    return (
                      <Link href={button.href || "#"} key={`button-${index}`}>
                        <a
                          className={finalButtonClass}
                          target={button.newTab ? "_blank" : "_self"}
                          rel={
                            button.newTab ? "noopener noreferrer" : undefined
                          }
                        >
                          {button.label}
                        </a>
                      </Link>
                    );
                  })}
                </div>
              ) : buttonLink && buttonTitle ? (
                <div className="mt-4">
                  <a
                    href={buttonLink}
                    className={`fourthBtn no-arrow m-0`}
                    target={buttonNewTab ? "_blank" : "_self"}
                  >
                    {buttonTitle}
                  </a>
                </div>
              ) : null}
              {hero?.active && hero?.jobSearch && (
                <JobSearch
                  options={{
                    searchResults: false,
                    searchFilters: false,
                    submitDestination: `${locale ? locale : ""}jobs`,
                  }}
                  translations={{
                    "input.placeHolder": "Job Title or Keyword",
                  }}
                />
              )}
            </div>
          </Col>
          {hero?.active && (
            <Col lg={6} className="position-relative mainImageWrapper">
              {video && video?.url ? (
                <div className="d-none d-md-block rounded-4 overflow-hidden ratio ratio-16x9 my-md-5">
                  <ReactPlayer
                    className="react-player"
                    url={video?.url}
                    controls={video?.controls || false}
                    playing={video?.autoplay || false}
                    muted={video?.autoplay || false}
                    playsinline={true}
                    width="100%"
                    height="100%"
                  />
                </div>
              ) : (
                <SourceFlowImage
                  src={
                    image?.url
                      ? image?.url
                      : "/site-assets/images/main-banner-v2.png"
                  }
                  size="413x448"
                  alt={image?.alt}
                  className="d-none d-md-block card-img rounded-4"
                  loading={"eager"}
                />
              )}
            </Col>
          )}
          <figure className="imageWrapper position-absolute p-0 m-0">
            <img
              src={
                hero?.active
                  ? "/site-assets/images/main-banner-overlay-v2.png"
                  : image?.url
                  ? image.url
                  : "/site-assets/images/sub-banner-about-us.png"
              }
              alt={image?.alt}
              loading="eager"
              className="card-img rounded-0"
            />
          </figure>
        </Row>
        {hero?.active && hero?.pageAnchor && (
          <AnchorLink
            offset="80"
            href={`#${hero?.pageAnchor}`}
            className="banner-anchor position-absolute"
            aria-label="Scroll Bottom"
          >
            <Arrow />
          </AnchorLink>
        )}
      </Container>
    </section>
  );
};

export default MainBanner;
